import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import { Tour } from 'src/app/model/tour/tour';
import { TourItem } from 'src/app/model/tour/tour-item';
import { PrintAddressPipe } from 'src/app/pipes/print-address.pipe';
import { ImmoIPPlacerTourRouteHelper } from './helper/immo-ip-placer-tour-route-helper';
import { ImmoIPPlacerTourOrderSubmitService } from 'src/app/services/immo-ip-placer-tour-order-submit/immo-ip-placer-tour-order-submit.service';
import { FormatPhoneNumber } from 'src/app/modules/app-pipes/format-phonenumber';

@Component({
  selector: 'immo-ip-placer-tour-route',
  templateUrl: './immo-ip-placer-tour-route.component.html',
  styleUrls: ['./immo-ip-placer-tour-route.component.scss'],
  providers: [PrintAddressPipe, FormatPhoneNumber]
})
export class ImmoIPPlacerTourRouteComponent implements OnInit, OnDestroy {
  @Input()
  tour: Tour;
  @Input()
  tourDateChangedOrDestroy: Subject<any>;

  loading: boolean = true;
  storingDragDrop: boolean = false;
  rerenderMap = new Subject<any>();

  constructor(
    private printAddressPipe: PrintAddressPipe,
    private immoIPPlacerTourOrderSubmitService: ImmoIPPlacerTourOrderSubmitService,
    private formatPhoneNumber: FormatPhoneNumber
  ) {}

  ngOnInit(): void {
    if (CollectionHelper.isPopulated(this.tour.tourItems)) {
      ImmoIPPlacerTourRouteHelper.processTourItems(
        this.tour.tourItems,
        this.printAddressPipe,
        this.formatPhoneNumber
      );
    }
    this.loading = false;
  }

  ngOnDestroy(): void {
    if (this.rerenderMap != null) {
      this.rerenderMap.complete();
      this.rerenderMap = null;
    }
  }

  async onListDrop(event: CdkDragDrop<TourItem[]>): Promise<void> {
    this.storingDragDrop = true;
    try {
      const prevIndex = this.tour.tourItems.findIndex(
        ti => ti.id === event.item.data.id
      );
      moveItemInArray(this.tour.tourItems, prevIndex, event.currentIndex);
      await this.immoIPPlacerTourOrderSubmitService.submitTourOrderChanges({
        id: this.tour.id,
        tourItemIdSequenceNumberPairs: this.tour.tourItems.map((ti, i) => {
          return {
            tourItemId: ti.id,
            sequenceNumber: i
          };
        })
      });
      this.rerenderMap.next();
    } finally {
      this.storingDragDrop = false;
    }
  }

  trackById(index: number, obj: any): number {
    return GeneralHelper.trackById(index, obj);
  }
}
